export const SET_VESTING_SCHEDULE = (state, payload) => {
    state.vestingSchedule = payload;
};
export const SET_ESO_OVERVIEW = (state, payload) => {
    state.esoOverview = payload;
};
export const SET_ESOP_TOKEN = (state, payload) => {
    state.esopToken = payload;
};
export const SET_ESOP_ORDER = (state, payload) => {
    state.esopOrder = payload;
};
export const SET_EMPLOYEE_INVITES = (state, payload) => {
    state.employeeInvite = payload;
};
export const SET_ALL_EMPLOYEE_INVITES = (state, payload) => {
    state.allEmployeeInvites = payload;
};
export const SET_EMPLOYEE_INVITE = (state, payload) => {
    state.employeeInfo = payload;
};
export const SET_INVITES_PAGE_INFO = (state, payload) => {
    state.pageInfo = payload;
};